import React, { useState } from "react";
import Modal from "@visiblethread/react-components/dist/components/Modal";
import Button, {
  buttonVariants,
} from "@visiblethread/react-components/dist/components/Button";
import { useDispatch } from "react-redux";
import { hideModal } from "slices/app/actions/modals";
import { modalTypes } from "constants/types";
import Dropdown, {
  dropdownTypes,
} from "@visiblethread/react-components/dist/components/Dropdown";
import { exportUsageReport } from "slices/systemAdmin/actions/systemAdmin";
import PropTypes from "prop-types";
import { exportActivityReport } from "slices/systemAdmin/actions/users";

export const exportModalTypes = {
  usage: "usage",
  activity: "activity",
};

const options = [
  { content: <span>All Time</span>, value: "all_time" },
  { content: <span>12 Months</span>, value: "12m" },
  { content: <span>6 Months</span>, value: "6m" },
  { content: <span>3 Months</span>, value: "3m" },
  { content: <span>1 Months</span>, value: "1m" },
];

const ExportReportModal = ({ exportType }) => {
  const dispatch = useDispatch();

  const [dropdownSelected, setDropdownSelected] = useState(options[0]);

  const handleCancel = () => {
    dispatch(hideModal(modalTypes.EXPORT_REPORT));
  };

  const handleExport = () => {
    if (exportType === exportModalTypes.usage) {
      dispatch(exportUsageReport(dropdownSelected.value));
    } else {
      dispatch(exportActivityReport(dropdownSelected.value));
    }
  };

  return (
    <Modal
      data-testid="exportReportModal"
      className="fade-in"
      show
      onDismiss={handleCancel}
      backdrop="static"
      centered
    >
      <Modal.Header closeButton>
        <b className="export__usage__modal__header">
          {exportType === exportModalTypes.usage
            ? "Export Usage Report"
            : "Export Activity Report"}
        </b>
      </Modal.Header>
      <Modal.Body
        className="export__usage__modal"
        data-testid="export-modal-body"
      >
        <span>Export data for the last:</span>
        <Dropdown
          type={dropdownTypes.simple}
          propsObject={{
            options,
            dropdownSelected,
            setDropdownSelected,
          }}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button
          data-test="saveButton"
          variant={buttonVariants.primary}
          onClick={handleExport}
          disabled={false}
          content="Export"
        />
        <Button
          data-test="cancelButton"
          variant={buttonVariants.secondary}
          onClick={handleCancel}
          content="Cancel"
        />
      </Modal.Footer>
    </Modal>
  );
};

export default ExportReportModal;

ExportReportModal.propTypes = {
  exportType: PropTypes.string.isRequired,
};
